// 浏览器侧边栏关闭后再打开的会话恢复。
// 浏览器在同一标签重新打开面板时沿用原来的 aisession,这里按 aisession 记住它最后显示的
// 本地会话 id(IndexedDB sessions 里的 id),挂载时据此载入。多个面板实例共用这张表。
const STORAGE_KEY = 'aihelp_panel_session_map';
// 只保留最近的若干个 aisession;被挤出的 aisession 工作区文件交给调用方清理
const MAX_ENTRIES = 30;

const readMap = () => {
  try {
    const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
  } catch (error) {
    return {};
  }
};

const writeMap = (map) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch (error) {
    // 存储失败只影响下次恢复
  }
};

export function getRestoreSessionId(aisession) {
  if (!aisession) return '';
  const entry = readMap()[aisession];
  return entry && entry.sessionId ? String(entry.sessionId) : '';
}

export function hasPanelSession(aisession) {
  return !!aisession && Object.prototype.hasOwnProperty.call(readMap(), aisession);
}

// 记录 aisession 当前显示的会话;返回被挤出表的 aisession 列表
export function rememberPanelSession(aisession, sessionId) {
  if (!aisession) return [];
  const map = readMap();
  if (sessionId) {
    map[aisession] = { sessionId: String(sessionId), time: Date.now() };
  } else {
    delete map[aisession];
  }
  const keys = Object.keys(map).sort((a, b) => (map[b].time || 0) - (map[a].time || 0));
  const evicted = keys.slice(MAX_ENTRIES);
  evicted.forEach(key => delete map[key]);
  writeMap(map);
  return evicted;
}
